module.exports = __webpack_public_path__ + "img/shady07.dcd0cbaf.jpg";